export default __webpack_public_path__ + "static/media/hht1_ep20_minisitcom_04.da8dc57c.png";